import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { TextField, NumberField, Dropdown } from 'components'

const defaultStyle = {
    margin: '1rem 0 0 0',
    labelWeight: 'bolder',
    fieldPadding: '0.2rem 0.5rem',
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin: ${props => props.styles.margin};
`

const Label = styled.div`
    font-weight: ${props => props.styles.labelWeight};
    font-size: 0.8rem;
    color: var(--text-color);
    margin-bottom: 0.4rem;
`

const Error = styled.div`
    font-size: 0.9rem;
    color: var(--error-color);
    margin-top: 0.2rem;
    :before {
        content: '*'
    }
`

const Success = styled.div`
    font-size: 0.9rem;
    color: var(--success-color);
    margin-top: 0.2rem;
    :before {
        content: '*'
    }
`
const Field = styled.div`
    padding: ${props => props.styles.fieldPadding};
    border-radius: 5px;
    background-color: var(--secondary-color);
    width: 100%;
    border: ${props => `2px solid ${props.error ? 'var(--error-color)'
                                    : props.success ? 'var(--success-color)'
                                    : props.selected ? 'var(--focus-color)'
                                    : 'var(--secondary-color)'}`};
    /* :hover {
        border: 2px solid var(--secondary-accent-color);
    }; */
`

const FormField = props => {
    const {
        type,
        label,
        value,
        placeholder,
        error,
        success,
        selected,
        options,
        onChange,
        onFocus,
        onBlur,
        onKeyDown,
        onKeyPress,
        onSelect,
        style,
        maxLength
    } = props
    let updatedStyle = Object.assign({}, defaultStyle, style)

    let content;
    switch(type){
        case 'TEXT':
            content = <TextField value={value} placeholder={placeholder} type='single' maxLength={maxLength}
                            onFocus={onFocus} onBlur={onBlur} onKeyDown={onKeyDown} onKeyPress={onKeyDown}
                            onChange={(event) => onChange(event.target.value)}/>
            break
        case 'PASSWORD':
            content = <TextField value={value} placeholder={placeholder} type='single' censor={true}
                            onFocus={onFocus} onBlur={onBlur} onKeyDown={onKeyDown} onKeyPress={onKeyDown}
                            onChange={(event) => onChange(event.target.value)}/>
            break
        case 'NUMBER':
            content = <NumberField value={value}/>
            break
        case 'DROPDOWN':
            content = <Dropdown options={options} onSelect={onSelect} style={{...updatedStyle, border: '2px solid tranparent'}} value={value}/>
            break
        default:
            content = <div>Something went wrong</div>
    }

    return (
        <Container styles={updatedStyle}>
            <Label styles={updatedStyle}>{label}</Label>
            <Field selected={selected} error={error} styles={updatedStyle}>{content}</Field>
            {success && <Success>{success}</Success>}
            {error ? <Error>{error}</Error> : null}
        </Container>
    )
}

export default FormField